<template>
  <v-card flat>
    <v-card-title>
      Contact Details
    </v-card-title>
    <v-card-text>
      <v-form ref="contactForm" lazy-validation>
        <v-alert
          v-model="showModalError"
          dismissible
          type="error"
          transition="scale-transition"
        >{{ modalError }}</v-alert>

        <v-text-field
          v-model="jobTitle"
          label="Job Title"
          required
          :rules="vruleFieldRequired"
        />

        <v-text-field
          v-model="name"
          label="Name"
          required
          :rules="vruleFieldRequired"
        />

        <v-text-field
          v-model="email"
          label="Email"
          type="email"
          required
          :rules="vruleValidEmailRequired"
        />

        <v-text-field
          v-model="phone"
          v-mask="'###-###-####'"
          label="Phone"
          type="tel"
          required
          :rules="vruleValidPhoneRequired"
        >
        </v-text-field>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <div class="flex-grow-1"></div>
      <v-btn @click="close">Cancel</v-btn>
      <v-btn color="primary" @click="validateAndSubmit">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import validationMixin from '@/validators/validations_mixin'
import { mapState, mapMutations } from 'vuex'
import { prop } from 'ramda'

export default {
  name: 'rooftop-contact',
  mixins: [validationMixin],
  data: function () {
    return {
      modalError: '',
      showModalError: false
    }
  },
  computed: {
    ...mapState('EmailSenderStore', ['emailSender']),
    jobTitle: {
      get: function () {
        return prop('job_title', this.emailSender)
      },
      set: function (val) {
        this.setEmailSenderProp({ type: 'setEmailSenderProp', field: 'job_title', value: val })
      }
    },
    name: {
      get: function () {
        return prop('name', this.emailSender)
      },
      set: function (val) {
        this.setEmailSenderProp({ type: 'setEmailSenderProp', field: 'name', value: val })
      }
    },
    email: {
      get: function () {
        return prop('email', this.emailSender)
      },
      set: function (val) {
        this.setEmailSenderProp({ type: 'setEmailSenderProp', field: 'email', value: val })
      }
    },
    phone: {
      get: function () {
        return prop('phone', this.emailSender)
      },
      set: function (val) {
        this.setEmailSenderProp({ type: 'setEmailSenderProp', field: 'phone', value: val })
      }
    }
  },
  methods: {
    ...mapMutations('EmailSenderStore', ['setEmailSenderProp']),
    validateAndSubmit () {
      if (this.$refs.contactForm.validate()) {
        this.save()
      }
    },
    save () {
      this.$store.dispatch('EmailSenderStore/saveEmailSender', this.emailSender)
        .then(emailSender => {
          this.$emit('save', emailSender)
          this.close()
        })
        .catch(error => {
          this.modalError = error.message
          this.showModalError = true
        })
    },
    close () {
      this.$refs.contactForm.reset()
      this.showModalError = false
      this.modalError = ''
      this.$emit('close')
    }
  }
}
</script>
